import { render } from "./add_level.vue?vue&type=template&id=fa7ddfde"
import script from "./add_level.vue?vue&type=script&lang=js"
export * from "./add_level.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sunshine\\code\\zydt\\独立部署版\\ywym\\ydd-zht-api\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__